export default "__VITE_ASSET__DWpSGmux__"